import { Stack, Text } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from 'react-map-gl';

export interface IlotPopupData {
  longitude: number;
  latitude: number;
  id: number;
  color?: string;
}

interface IlotPopupProps {
  data: IlotPopupData | null;
  onClose: () => void;
}

export const IlotPopup: FC<IlotPopupProps> = ({ data, onClose }) => {
  const { t } = useTranslation();
  if (!data) return null;

  return (
    <Popup
      anchor="bottom"
      closeOnClick={false}
      closeOnMove={false}
      latitude={data.latitude}
      longitude={data.longitude}
      offset={[0, -15]}
      onClose={onClose}
    >
      <Stack gap="xs">
        <Text c="dimmed" fw={500} size="xs" tt="uppercase">
          {t('common.ilot') || 'Ilot'}
        </Text>
        <Text size="sm" fw={500}>
          ID: {data.id}
        </Text>
        {data.color && (
          <Text size="xs" c="dimmed">
            {t('common.color') || 'Color'}:{' '}
            <span
              style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: data.color,
                borderRadius: '2px',
                verticalAlign: 'middle',
                marginLeft: '4px',
              }}
            />
          </Text>
        )}
      </Stack>
    </Popup>
  );
};
